import { lazy } from 'react';

// const CompanyIndex = lazy(() => import('@/pages/company/index/index'));
const CompanyInfo = lazy(() => import('@/pages/company/info/index'));
const BankAccount = lazy(() => import('@/pages/company/bank/index'));
const Invoice = lazy(() => import('@/pages/company/invoicing/index'));
const CompanyDetail = lazy(() => import('@/pages/company/detail/index'));
const CompanyAddress = lazy(() => import('@/pages/company/address/index'));
const CompanyDelivery = lazy(() => import('@/pages/company/delivery/index'));
const CompanyAptitude = lazy(() => import('@/pages/company/aptitude/index'));
const CategoryQualification = lazy(() => import('@/pages/company/category/index/index'));
const CompanyApplication = lazy(() => import('@/pages/company/application/index'));
const CompanyApplicationDetail = lazy(() => import('@/pages/supplierVerify/detail/index'));
const CategoryEdit = lazy(() => import('@/pages/company/category/edit'));
const StaffIndex = lazy(() => import('@/pages/company/staff/index'));
const RoleIndex = lazy(() => import('@/pages/company/role/index'));
const StaffExamine = lazy(() => import('@/pages/company/staff/examine/index'));
const StaffLink = lazy(() => import('@/pages/company/staff/link/index'));
const ContractIndex = lazy(() => import('@/pages/company/contract/index/index'));
const ContractDetail = lazy(() => import('@/pages/company/contract/detail'));
const ContractPerformance = lazy(() => import('@/pages/company/performance/index'));
const ContractPerformanceDetail = lazy(() => import('@/pages/company/performance/detail'));
const Schedule = lazy(() => import('@/pages/company/schedule/index'));
const ScheduleDetail = lazy(() => import('@/pages/company/schedule/detail'));
const InvoiceNotice = lazy(() => import('@/pages/company/settlementDoc/invoiceNotice/index/index'));
const ReceivingRecord = lazy(() => import('@/pages/company/settlementDoc/invoiceNotice/receivingRecord'));
const SettlementDoc = lazy(() => import('@/pages/company/settlementDoc/settlementDoc/index/index'));
const UploadInvoice = lazy(() => import('@/pages/company/settlementDoc/settlementDoc/uploadInvoice'));

export const companyRouter = [
  {
    // path: '/company',
    key: 'companyManagement',
    label: 'Company Management', //公司管理
    children: [
      {
        path: '/company/info',
        element: <CompanyInfo />,
        key: 'companyInfo',
        parentKey: 'companyManagement',
        label: 'Company Basic Information', //公司基本信息
        handle: { menuKey: 'companyInfo', parentKey: 'companyManagement' },
      },
      {
        path: '/company/bank',
        element: <BankAccount />,
        key: 'companyBankAccount',
        parentKey: 'companyManagement',
        label: 'Bank Account Information', //银行账户信息
        // hidden: true,
        handle: { menuKey: 'companyBankAccount', parentKey: 'companyManagement' },
      },
      {
        path: '/company/detail',
        element: <CompanyDetail />,
        key: 'companyDetail',
        parentKey: 'companyManagement',
        label: 'Company Detail Information', //公司详情信息
        handle: { menuKey: 'companyDetail', parentKey: 'companyManagement' },
      },
      {
        path: '/company/invoice',
        element: <Invoice />,
        key: 'companyInvoice',
        parentKey: 'companyManagement',
        label: 'Invoice Information', //公司开票信息
        // hidden: true,
        handle: { menuKey: 'companyInvoice', parentKey: 'companyManagement' },
      },
      {
        path: '/company/address',
        element: <CompanyAddress />,
        key: 'companyAddress',
        parentKey: 'companyManagement',
        label: 'Company Address Management', // '公司地址管理',
        handle: { menuKey: 'companyAddress', parentKey: 'companyManagement' },
      },
      {
        path: '/company/delivery',
        element: <CompanyDelivery />,
        key: 'companyDelivery',
        parentKey: 'companyManagement',
        label: 'Company Delivery Management', //'公司配送管理',
        handle: { menuKey: 'companyDelivery', parentKey: 'companyManagement' },
      },
      {
        path: '/company/aptitude',
        element: <CompanyAptitude />,
        key: 'companyAptitude',
        parentKey: 'companyManagement',
        label: 'Company License Management', // '公司资质管理',
        handle: { menuKey: 'companyAptitude', parentKey: 'companyManagement' },
      },
      {
        path: '/company/category',
        element: <CategoryQualification />,
        key: 'companyCategoryQualification',
        parentKey: 'companyManagement',
        label: 'Category Qualification', // '品种资质信息',
        handle: { menuKey: 'companyCategoryQualification', parentKey: 'companyManagement' },
      },
      {
        path: '/company/category/edit',
        element: <CategoryEdit />,
        key: 'categoryEdit',
        parentKey: 'companyManagement',
        label: 'qualification information', // '品种资质信息变更',
        hidden: true,
        handle: { menuKey: 'companyCategoryQualification', parentKey: 'companyManagement' },
      },
      {
        path: '/company/application',
        element: <CompanyApplication />,
        key: 'companyApplication',
        parentKey: 'companyManagement',
        label: 'Application Review Record', // '申请审核记录',
        handle: { menuKey: 'companyApplication', parentKey: 'companyManagement' },
      },
      {
        path: '/company/application/detail/:id/:approval_no/:company_id?',
        element: <CompanyApplicationDetail />,
        key: 'companyApplicationDetail',
        parentKey: 'companyManagement',
        hidden: true,
        label: 'Application Review Record Detail', // '申请审核记录详情',
        handle: { menuKey: 'companyApplication', parentKey: 'companyManagement' },
      },

    ],
  },
  {
    // path: '/company',
    key: 'staffManagement',
    label: 'User Account', //员工账号
    children: [
      {
        path: '/company/staff',
        element: <StaffIndex />,
        key: 'staffIndex',
        parentKey: 'staffManagement',
        label: 'Account Management', // '员工账号管理',
        handle: { menuKey: 'staffIndex', parentKey: 'staffManagement' },
      },
      {
        path: '/company/role',
        element: <RoleIndex />,
        key: 'RoleIndex',
        parentKey: 'staffManagement',
        label: 'User Role Management', // '员工角色管理',
        handle: { menuKey: 'RoleIndex', parentKey: 'staffManagement' },
      },
      {
        path: '/company/staff/examine',
        element: <StaffExamine />,
        key: 'accountJoinExamine',
        parentKey: 'staffManagement',
        hidden: true,
        label: 'Review account association applications', // '账号关联申请审核',
        handle: { menuKey: 'staffIndex', parentKey: 'staffManagement' },
      },
      {
        path: '/company/staff/link',
        element: <StaffLink />,
        key: 'staffLink',
        parentKey: 'staffManagement',
        hidden: true,
        label: 'Link Account', // '账号关联申请审核',
        handle: { menuKey: 'staffIndex', parentKey: 'staffManagement' },
      },
    ]
  },
  {
    // path: '/company',
    key: 'contractManagement',
    label: 'Contract Management', //合同管理
    children: [
      {
        path: '/company/contract',
        element: <ContractIndex />,
        key: 'contractManagementMain',
        parentKey: 'contractManagement',
        label: 'Contract Management', // '合同管理',
        handle: { menuKey: 'contractManagementMain', parentKey: 'contractManagement' },
      },
      {
        path: '/company/contract/detail/:contract_no/:tab_key?',
        element: <ContractDetail />,
        key: 'detailContractManagement',
        hidden: true,
        handle: { menuKey: 'contractManagementMain', parentKey: 'contractManagement' },
      },
      {
        path: '/company/contract_performance/index',
        element: <ContractPerformance />,
        key: 'contractPerformance',
        parentKey: 'contractManagement',
        label: 'Contract Performance', // '合同履约',
        handle: { menuKey: 'contractPerformance', parentKey: 'contractManagement' },
      },
      {
        path: '/company/contract_performance/detail',
        element: <ContractPerformanceDetail />,
        key: 'ContractPerformanceDetail',
        parentKey: 'contractManagement',
        label: 'Contract Performance', // '合同履约详情',
        hidden: true,
        handle: { menuKey: 'contractPerformance', parentKey: 'contractManagement' },
      },
      {
        path: '/company/schedule/index',
        element: <Schedule />,
        key: 'scheduleRecord',
        parentKey: 'contractManagement',
        label: 'Scheduling Record', // '预约发货记录',
        handle: { menuKey: 'scheduleRecord', parentKey: 'contractManagement' },
      },
      {
        path: '/company/schedule/detail',
        element: <ScheduleDetail />,
        key: 'ScheduleDetail',
        parentKey: 'contractManagement',
        label: 'Scheduling Record Detail', // '预约发货记录详情',
        hidden: true,
        handle: { menuKey: 'scheduleRecord', parentKey: 'contractManagement' },
      },
    ]
  },
  {
    // path: '/company',
    key: 'settlementManagement',
    label: 'Settlement Management', //结算管理
    children: [
      {
        path: '/company/invoice_notice', //settlement
        element: <InvoiceNotice />,
        key: 'invoiceNotice',
        parentKey: 'settlementManagement',
        label: 'Invoice Notice', // '开票通知',
        handle: { menuKey: 'invoiceNotice', parentKey: 'settlementManagement' },
      },
      {
        path: '/company/invoice_notice/record', //settlement
        element: <ReceivingRecord />,
        key: 'receivingRecord',
        parentKey: 'settlementManagement',
        label: 'Invoice Notice', // '开票通知',
        hidden: true,
        handle: { menuKey: 'invoiceNotice', parentKey: 'settlementManagement' },
      },
      {
        path: '/company/settlement_doc',
        element: <SettlementDoc />,
        key: 'settlementDoc',
        parentKey: 'settlementManagement',
        label: 'Settlement Doc', // '结算通知',
        handle: { menuKey: 'settlementDoc', parentKey: 'settlementManagement' },
      },
      {
        path: '/company/settlement_doc/invoice',
        element: <UploadInvoice />,
        key: 'uploadInvoice',
        parentKey: 'settlementManagement',
        label: 'Upload Invoice', // '结算通知',
        hidden: true,
        handle: { menuKey: 'settlementDoc', parentKey: 'settlementManagement' },
      },
    ]
  },
];